import { render, staticRenderFns } from "./ResearchBasicInfoForm.vue?vue&type=template&id=601b3760&"
import script from "./ResearchBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./ResearchBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports